
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 51, 102, 0.8), rgba(30, 64, 175, 0.8)), url(https://public.readdy.ai/ai/img_res/191a6edb1cec17e18621873accabb03f.jpg)`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            新政下的破局之道
          </h1>
          <h2 className="text-2xl md:text-3xl font-light mb-8 text-blue-100">
            2025年各类外贸客户精准财税合规解决方案
          </h2>
          <p className="text-xl mb-12 text-blue-50">
            深度解析0110退税、1039无票出口与香港转口贸易的综合应用
          </p>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-16">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4 border border-white/20">
              <div className="flex items-center space-x-3">
                <i className="ri-calendar-line text-2xl text-blue-200"></i>
                <span className="text-lg">2025年1月</span>
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4 border border-white/20">
              <div className="flex items-center space-x-3">
                <i className="ri-building-line text-2xl text-blue-200"></i>
                <span className="text-lg">天建产业服务</span>
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">合规保障</h3>
              <p className="text-blue-100">全面符合新政要求</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">降本增效</h3>
              <p className="text-blue-100">优化税负结构</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">全球布局</h3>
              <p className="text-blue-100">国际化运营支持</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 border-2 border-white rounded-full flex items-center justify-center">
          <i className="ri-arrow-down-line text-white"></i>
        </div>
      </div>
    </section>
  );
}
